/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelseeker3Inputs */



/**
* | output |
* | --- |
* | "The Wanderer" |
*
* @param {Personalityarchetypelabelseeker3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelseeker3 = /** @type {((inputs?: Personalityarchetypelabelseeker3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelseeker3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Wanderer")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Nómada")
	return /** @type {LocalizedString} */ ("Странник")
});
export { personalityarchetypelabelseeker3 as "personalityArchetypeLabelSeeker" }